<template>
  <div
    id="container"
    :style="{'paddingBottom':quickareashow ? '300px' : ''}"
  >
    <check-module
      :title="`全部`"
      :padding-top="false"
      style="position: relative;padding-bottom: 20px !important;"
    >
      <div style="position:absolute;right: 20px;top: 20px;">
        <el-link
          @click="quickareashow = true"
          type="primary"
          icon="el-icon-thumb"
          :underline="false"
        >拖入快捷区域
        </el-link>
      </div>
    </check-module>
    <div
      v-for="item in quickarealist"
      :key="item.title"
      @mousedown="selectItem(item.id)"
    >
      <check-module :title="item.title">
        <el-row>
          <vuedraggable
            v-model="item.areachild"
            element="div"
            :group="item.id"
            :options="{animation:200,sort: false,group:{name:item.id}}"
          >
            <transition-group
              name="no"
              class="list-group"
              tag="div"
            >
              <el-col
                :span="4"
                v-for="childitem in item.areachild"
                :key="childitem.icon"
                style="text-align: center;font-size: 14px;margin-bottom: 30px;"
              >
                <div
                  class="area_module"
                  :style="{'backgroundColor':childitem.bgcolor}"
                >
                  <span
                    class="iconfont"
                    :class="childitem.icon"
                  ></span>
                </div>
                <div>{{childitem.subtitle}}</div>
              </el-col>
            </transition-group>
          </vuedraggable>
        </el-row>
      </check-module>
    </div>
    <div
      class="bottom_quickarea"
      v-show="quickareashow"
    >
      <check-module
        :title="`快捷区域`"
        :padding-top="false"
        style="position: relative;margin-bottom: 0;"
      >
        <div
          style="position:absolute;right: 20px;top:10px;text-align: right;font-size: 16px;cursor: pointer"
          @click="quickareashow = false"
        >
          <span class="el-icon-close"></span>
        </div>
      </check-module>
      <div style="height: 250px;overflow-y: auto">
        <check-module :ishow-title="false">
          <el-row class="quick_list">
            <vuedraggable
              v-model="quickareaData"
              :options="{animation: 200,group:quickfalgname}"
              @change="quickareaDataChange"
            >
              <transition-group
                name="no"
                class="list-group"
                tag="div"
              >
                <el-col
                  :span="4"
                  v-for="childitem in quickareaData"
                  :key="childitem.icon"
                  style="text-align: center;font-size: 14px;margin-bottom: 30px;position: relative"
                >
                  <div
                    class="area_module"
                    :style="{'backgroundColor':childitem.bgcolor}"
                  >
                    <span
                      class="iconfont"
                      :class="childitem.icon"
                    ></span>
                  </div>
                  <span
                    @click="deleteQuickItem(childitem)"
                    style="position:absolute;left: 66%;top:0px;width:20px;height: 20px;border-radius: 50%;background: #D35E5E;color: #fff;text-align: center;line-height: 20px;cursor: pointer"
                    class="el-icon-close"
                  ></span>
                  <div>{{childitem.subtitle}}</div>
                </el-col>
              </transition-group>
            </vuedraggable>
          </el-row>
        </check-module>
      </div>
    </div>
  </div>
</template>

<script>
import CheckModule from '@/components/checkLayout/module/checkModule'
import { quickarealist } from '@/meun/quickarea'
import vuedraggable from 'vuedraggable'
import { mapMutations } from 'vuex'
import workbench from '@/api/workbench'
import { isSuccess } from '@/util/tool'
import { deepClone } from '@/util'

export default {
  name: 'quickarea',
  components: {
    CheckModule,
    vuedraggable
  },
  data () {
    return {
      quickarealist,
      quickareashow: false,
      quickfalgname: 'xiaoshou',
      quickareaData: []
    }
  },
  mounted () {
    this.quickarealist = deepClone(this.quickarealist)
    workbench.getUserQuickarea({}).then(res => {
      this.filterPowerMethods(res)
    })
  },
  methods: {
    ...mapMutations(['updataQuickAreaData']),
    filterPowerMethods (res) {
      workbench.filterPowerMethods().then(resex => {
        const obj = resex.data.obj
        if (isSuccess(resex) && obj && obj.length) {
          if (isSuccess(res)) {
            this.quickareaData = deepClone(JSON.parse((res.data.obj && res.data.obj.quickArea) || '[]'))
            this.quickareaData = this.quickareaData.filter(item => {
              const i = obj.findIndex(ax => ax.id === item.id)
              return i !== -1
            })
            const { quickarealist, quickareaData } = this
            quickarealist.forEach(item => {
              item.areachild = item.areachild.filter(childitem => {
                const childitemtitle = childitem.subtitle
                const i = quickareaData.findIndex(ex => ex.subtitle === childitemtitle)
                const ix = obj.findIndex(ax => ax.id === childitem.id)
                return i === -1 && ix !== -1
              })
            })
            this.quickarealist = quickarealist.filter(item => item.areachild.length)
          }
        } else {
          this.quickarealist = deepClone(this.quickarealist)
          this.quickareaData = []
        }
      })
    },
    selectItem (id) {
      this.quickfalgname = id
    },
    quickareaDataChange () {
      const { quickareaData } = this
      this.updataQuickAreaData(quickareaData)
      this.saveAreaData()
    },
    saveAreaData () {
      const { quickareaData } = this
      workbench.setUserQuickarea({
        userQuickDataStr: JSON.stringify(quickareaData)
      }).then(res => {
        this.$message.success(res.data.msg)
      })
    },
    deleteQuickItem (item) {
      const { quickarealist, quickareaData } = this
      quickarealist.forEach(items => {
        if (items.id === item.patherid) {
          items.areachild.push(item)
        }
      })
      this.quickareaData = quickareaData.filter(v => {
        return v.subtitle !== item.subtitle
      })
      this.updataQuickAreaData(quickareaData.filter(v => {
        return v.subtitle !== item.subtitle
      }))
      this.saveAreaData()
    }
  }
}
</script>

<style
  scoped
  lang="less"
>
  .area_module {
    width: 60px;
    height: 60px;
    color: #fff;
    text-align: center;
    line-height: 60px;
    border-radius: 10px;
    margin: 15px auto;

    .iconfont {
      padding: 0;
      font-size: 30px;
    }
  }

  .item-box-content {
    padding-bottom: 10px !important;
  }

  .bottom_quickarea {
    position: fixed;
    left: 215px;
    height: 300px;
    overflow-y: auto;
    right: 0;
    bottom: 0;
    background: #fff;
    z-index: 99;
    box-shadow: 10px 0px 10px 10px rgba(0, 0, 0, 0.1);
  }

  .flip-list-move {
    transition: transform 0.5s;
  }

  .no-move {
    transition: transform 0s;
  }

  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
  }

  .list-group {
    min-height: 20px;
    overflow: hidden;
  }

  .list-group-item {
    cursor: move;
  }

  .list-group-item i {
    cursor: pointer;
  }
</style>
